/**
 * BootScene — the first scene. It does the cheap, synchronous setup (background,
 * reduced-motion flag if any) and immediately hands off to PreloadScene, which does
 * the real dataset/sprite loading behind a calm progress UI. Boot stays tiny so the
 * first paint is instant.
 *
 * Flow: Boot -> Preload -> (NewGame | Town). Transitions are gentle fades (flow.ts).
 */
import Phaser from 'phaser';
import { COLORS, CSS, FONT } from './ui/theme.js';
import { Layout } from './layout/index.js';
import { goTo } from './flow.js';

export class BootScene extends Phaser.Scene {
  private layout!: Layout;
  private title?: Phaser.GameObjects.Text;

  constructor() {
    super('Boot');
  }

  create(): void {
    this.cameras.main.setBackgroundColor(COLORS.bg);
    this.layout = Layout.attach(this);

    this.title = this.add
      .text(0, 0, 'Parallel Routes', {
        fontFamily: FONT.family,
        fontSize: `${FONT.size.xl}px`,
        color: CSS.textMuted,
      })
      .setOrigin(0.5);

    this.relayout();
    this.layout.on('change', () => this.relayout());

    // Hand off to Preload on the next tick (lets the first frame paint instantly).
    this.time.delayedCall(60, () => goTo(this, 'Preload', { duration: 0 }));
  }

  private relayout(): void {
    this.title?.setPosition(this.layout.centerX, this.layout.centerY);
  }
}
